<template>
  <div class="page-body container mx-auto px-10 space-y-5 font-heiti text-lg">
    <div class="">评测机构签署页</div>
    <div>
      <div
        class="text-blue-level w-full text-center border-b border-solid border-black"
      >
        项目组成员
      </div>
      <p class="text-blue-level pt-10">
        【项目总负责人】<img class="inline h-7" ref="five" alt="" src="" />
      </p>
      <p class="text-blue-level pt-10">
        【项目总工程师】<img class="inline h-7" ref="six" alt="" src="" />
      </p>
      <p class="text-blue-level pt-10" style="letter-spacing: 0.45rem">
        【线上文审】<img
          class="inline h-7"
          ref="seven"
          alt=""
          v-for="(_, i) in info.strSeven"
          src=""
          :key="i"
        />
      </p>
      <p class="text-blue-level pt-10" style="letter-spacing: 0.2rem">
        【现场评测组】<img
          class="inline h-7"
          alt=""
          ref="right"
          v-for="(_, i) in info.strRight"
          src=""
          :key="i"
        />
      </p>
      <p class="text-blue-level pt-10" style="letter-spacing: 0.45rem">
        【质检校核】<img
          class="inline h-7"
          alt=""
          ref="nine"
          v-for="(_, i) in info.strNine"
          src=""
          :key="i"
        />
      </p>
    </div>
    <div class="pt-5">
      <div
        class="text-blue-level w-full text-center border-b border-solid border-black"
      >
        评测机构
      </div>
      <div class="flex py-20">
        <div class="flex-1">
          <div class="text-center whitespace-nowrap font-bold">
            吉林吉大通信设计院股份有限公司
          </div>
          <div class="text-center font-kaiti">（盖章）</div>
        </div>
        <div class="flex-1">
          <div class="text-center whitespace-nowrap font-bold">
            吉林省电子技术研究所
          </div>
          <div class="text-center font-kaiti">（盖章）</div>
        </div>
      </div>
    </div>
    <div>
      <div
        class="text-blue-level w-full text-center border-b border-solid border-black"
      >
        报告日期
      </div>
      <div class="text-center pt-2">
        {{
          (info.reportDate || "2024-01-01")
            .substring(0, 10)
            .replace("-", "年")
            .replace("-", "月")
        }}日
      </div>
      <div class="text-center pt-14 font-bold">
        郑重声明：本报告若未加盖骑缝章，则视为无效。
      </div>
    </div>
  </div>
</template>

<script>
// 签署页
import { getFile } from "@/api/enterprise";

export default {
  props: ["info"],
  mounted() {
    this.loadImages();
  },
  methods: {
    loadImages() {
      this.getAvatar(this.info.strFive).then((url) => {
        this.$refs.five.src = url;
      });
      this.getAvatar(this.info.strSix).then((url) => {
        this.$refs.six.src = url;
      });
      this.info.strSeven.forEach((id, i) => {
        this.getAvatar(this.info.e.find((v) => v.id === id)?.avatar).then(
          (url) => {
            this.$refs.seven[i].src = url;
          }
        );
      });
      this.info.strRight.forEach((id, i) => {
        this.getAvatar(this.info.e.find((v) => v.id === id)?.avatar).then(
          (url) => {
            this.$refs.right[i].src = url;
          }
        );
      });
      this.info.strNine.forEach((id, i) => {
        this.getAvatar(this.info.e.find((v) => v.id === id)?.avatar).then(
          (url) => {
            this.$refs.nine[i].src = url;
          }
        );
      });
    },
    async getAvatar(id) {
      try {
        const res = await getFile(id);
        return URL.createObjectURL(res.data);
      } catch (error) {
        console.error("image load fail");
      }
    },
  },
};
</script>
